import React from 'react';

import CloseButton from 'components/CloseButton';

export default function BlockDisplay({
  title, model, forecastDate, rmv, startDate, endDate,
  sliceEndDate, sliceStartDate,
  runtime, member, onBlockDelete,
}: {
  title: string,
  model: string,
  forecastDate?: string,
  rmv: boolean,
  startDate: string,
  endDate: string,
  sliceEndDate: string,
  sliceStartDate: string,
  runtime?: string | null,
  member?: string | null,
  onBlockDelete?: () => void,
}) {
  return (
    <div className="flux-personalized-block">
      <div className="block-header d-flex justify-content-between align-items-center">
        <span>{title}</span>
        {onBlockDelete && (
          <CloseButton onClick={onBlockDelete} label="" id={`${sliceStartDate}_${sliceEndDate}`} />
        )}
      </div>
      <div className="block-body">
        <div className="block-fields-grid">
          <div className="block-field">
            <span className="block-label">Modelo:</span>
            <span className="block-value block-model">{model}</span>
          </div>
          <div className="block-field">
            <span className="block-label">Viés:</span>
            <span className="block-value">
              {rmv ? 'COM' : 'SEM'}
              {' remoção'}
            </span>
          </div>
          {forecastDate && (
            <div className="block-field">
              <span className="block-label">Previsão:</span>
              <span className="block-value">{forecastDate}</span>
            </div>
          )}
          {runtime && (
            <div className="block-field">
              <span className="block-label">Runtime:</span>
              <span className="block-value">{runtime}</span>
            </div>
          )}
          {member && (
            <div className="block-field">
              <span className="block-label">Membro:</span>
              <span className="block-value">{member}</span>
            </div>
          )}
        </div>
        <div className="block-dates-row">
          <div className="block-field">
            <span className="block-label">Início:</span>
            <span className="block-value">
              {startDate}
              {sliceStartDate ? ` H ${sliceStartDate}` : ''}
            </span>
          </div>
          <div className="block-field">
            <span className="block-label">Fim:</span>
            <span className="block-value">
              {endDate}
              {sliceEndDate ? ` H ${sliceEndDate}` : ''}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
